import { ShoppingBag } from 'lucide-react';
import { useCart } from '@/context/CartContext';

const FloatingCartButton = () => {
  const { cartItemCount, setIsCartOpen, cartTotal } = useCart();

  if (cartItemCount === 0) return null;

  return (
    <button
      onClick={() => setIsCartOpen(true)}
      aria-label={`Abrir carrito, ${cartItemCount} articulos`}
      data-testid="floating-cart-btn"
      className="fixed right-4 bottom-24 sm:right-6 sm:bottom-8 z-[110] flex items-center gap-2 rounded-full bg-[#C44536] text-white shadow-2xl px-4 py-3 sm:px-5 sm:py-3.5 hover:bg-[#9B2F24] transition-all active:scale-95 animate-fade-in-up"
      style={{ boxShadow: '0 12px 28px rgba(196,69,54,0.45)' }}
    >
      <div className="relative">
        <ShoppingBag className="w-5 h-5" />
        <span
          className="absolute -top-2 -right-2 bg-[#E28743] text-[#2D231E] text-[10px] font-bold rounded-full min-w-[18px] h-[18px] flex items-center justify-center px-1"
          data-testid="floating-cart-count"
        >
          {cartItemCount}
        </span>
      </div>
      <span className="font-sans font-semibold text-sm sm:text-base" data-testid="floating-cart-total">
        {cartTotal.toFixed(2)} EUR
      </span>
    </button>
  );
};

export default FloatingCartButton;
